import { Fragment } from 'react';
import Icon from 'components/Icon';

const HasIcon = Component =>
  function HasIcon({ icon, iconClassName, ...rest }) {
    return (
      <Fragment>
        <Component {...rest} />
        <Icon icon={icon} className={iconClassName} />
      </Fragment>
    );
  };

export default HasIcon;
